import { Group, Button, TextInput, NumberInput, Select, Switch, Loader } from '@mantine/core';

import { useCreateConversionPair } from '../hooks/use-create-conversion-pair';

type Props = {
  onClose: () => void;
};

export const CreateConversionPairForm = (props: Props) => {
  const { onClose } = props;
  const {
    avalableCurrencies,
    form,
    marketRate,
    isRateLoading,
    isLoading,
    autoRefresh,
    handleSubmit,
  } = useCreateConversionPair(onClose);

  const currencies = avalableCurrencies.map((currency) => ({
    value: currency,
    label: currency,
  }));

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Select
        label="Валюта счёта"
        placeholder="Выберите валюту"
        withAsterisk
        searchable
        data={currencies}
        key={form.key('baseCurrency')}
        {...form.getInputProps('baseCurrency')}
      />
      <Select
        label="Валюта оплаты"
        placeholder="Выберите валюту"
        withAsterisk
        searchable
        data={currencies}
        key={form.key('quoteCurrency')}
        {...form.getInputProps('quoteCurrency')}
      />
      <Switch
        mt={10}
        label="Автоматически обновлять курс"
        key={form.key('autoRefresh')}
        {...form.getInputProps('autoRefresh', { type: 'checkbox' })}
      />

      {autoRefresh
        ? (
          <TextInput
            label="Курс биржи"
            placeholder="Выберите валюты пары"
            disabled
            value={marketRate?.rate ?? ''}
            rightSection={isRateLoading ? <Loader size="xs" /> : null}
          />
        )
        : (
          <NumberInput
            label="Курс"
            withAsterisk
            min={0}
            decimalScale={18}
            key={form.key('rate')}
            {...form.getInputProps('rate')}
          />
        )
      }

      <NumberInput
        label="Наценка (%)"
        decimalScale={10}
        key={form.key('markupPercent')}
        {...form.getInputProps('markupPercent')}
      />

      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit" loading={isLoading}>
          Добавить
        </Button>
      </Group>
    </form>
  );
};
